import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "disabled"]
const _hoisted_2 = { class: "block text-left font-normal text-sm text-brown ml-2" }


import CheckIcon from "@/components/icons/CheckIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
  inputId: {
    type: String,
  },
  isEnabled: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
  },
},
  emits: ["toggle"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["relative w-full flex items-center", __props.isDisabled ? 'opacity-60' : 'cursor-pointer'])
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      class: _normalizeClass(["peer appearance-none min-w-6 min-h-6 rounded border border-ternary bg-secondary checked:bg-active checked:border-active", { 'cursor-pointer': !__props.isDisabled }]),
      checked: __props.isEnabled,
      disabled: __props.isDisabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
    }, null, 42, _hoisted_1),
    _createVNode(CheckIcon, { class: "absolute opacity-0 peer-checked:opacity-100 pointer-events-none ml-1" }),
    _renderSlot(_ctx.$slots, "label", { label: __props.label }, () => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1)
    ])
  ], 2))
}
}

})